"use strict";

var LoggerInstance = require("js-logger").get("PlaidHelper");

var PlaidApi = require("../api/PlaidApi");

var Spinner = require("../client/Spinner");

var BootstrapPrompt = require("../shared/BootstrapPrompt");

module.exports = {
	parentSelector: `
		[data-component='createAccountAndCheckout'],
		[data-component='savedPayments'],
		[data-component='accountSavedPayments'],
		[data-component='myRecurringPayment.editPayment'],
		[data-component='myMagazineMailSubscriptions.populated.singleMagazineMail.edit'],
		[data-component='myMagazineEmailSubscriptions.populated.singleMagazineEmail.edit'],
		[data-component='myMembershipSubscriptions.populated.singleMembership.edit']
	`,
	initialize: function($parent) {
		$($parent || "body").find("button[data-component='plaidButton']").click((event) => {
			if (!$parent) {
				// Need to find actual parent
				$parent = $(event.currentTarget).closest(this.parentSelector);
			}

			Spinner.showSpinner();
			PlaidApi.generatePlaidLinkToken().then(response => {
				if (response && response.linkToken) {
					var linkToken = response.linkToken;
					this.openPlaidLink(linkToken, $parent);
				} else {
					// Some error occurred where the link token was not returned.
					this.handlePlaidError("No Link token generated. Response:" + JSON.stringify(response));
				}
			}).catch(error => {
				this.handlePlaidError(error);
			});
		});

		this.plaidDisplayMessages = window.AccountActions.getPlaidDisplayMessages();
	},

	openPlaidLink: function(linkToken, $parent) {
		if (this.handler) {
			this.handler.destroy();
		}

		this.handler = Plaid.create({
			token: linkToken,
			onExit: function(err, metadata) {
				if (err != null) {
					console.log(err);
				}
				Spinner.removeSpinner();
			},
			onSuccess: function(public_token, metadata) {
				PlaidApi.getEftAccountData(public_token, metadata.accounts).then(response => {
					if (response) {
						if (!response.success) {
							if (response.message === "Multiple bank accounts were selected.  Please try again but only select a single bank account.") {
								this.handlePlaidError(response.message, this.plaidDisplayMessages.multipleBankAccountsSelected);
							}
							else {
								this.handlePlaidError(response.message);
							}

							return;
						}

						// If there is an add New Payment Link in the parent, click this to enable the payment form to appear.
						$parent.find("[data-dynamic-href='addNewPayment']").click();

						var uniqueName = $parent.find("[data-component='PaymentTypeSelector.label'] input[value='EFT']").attr("name").replace("paymentType", "");

						AccountActions.setSelectedPaymentType(uniqueName, "EFT");

						$parent.find("input[data-component='eftPayment.routingNumber']").val(response.routingNumber);
						$parent.find("input[data-component='eftPayment.accountNumber']").val(response.accountNumber);
						if (response.accountType === "savings") {
							$parent.find("[data-component='eftAccountTypeSelector.savings'] input[value='SAVINGS']").click();
						} else {
							$parent.find("[data-component='eftAccountTypeSelector.checking'] input[value='CHECKING']").click();
						}
						Spinner.removeSpinner();
					} else {
						// Some error occurred where the EFT data was not returned.
						var systemErrorMessage = "No EFT data returned. Response:" + JSON.stringify(response);
						this.handlePlaidError(systemErrorMessage);
					}
				}).catch(error => {
					this.handlePlaidError(error);
				});
			}.bind(this)
		});

		this.handler.open();
	},

	handlePlaidError: function(systemErrorMessage, clientErrorMessage) {
		if (!clientErrorMessage) {
			clientErrorMessage = this.plaidDisplayMessages.unknownError;
		}

		LoggerInstance.error(systemErrorMessage);
		Spinner.removeSpinner();
		BootstrapPrompt.alert(clientErrorMessage);
	}
};
